import React from "react";
import { Link } from "react-router-dom";
import Teams from "../../api/team";
import lineGreen from "../../images/service/liine-green.svg";


const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const TeamSection = (props) => {

    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-12">
                        <div className="section-title text-center">
                            <span style={{color: '#0D0A0B'}}>Building Our Community Together</span>
                            <h2>Meet Our <span style={{position: 'relative', color: '#2A896F'}}>Committee
                                <img src={lineGreen} alt="" style={{position: 'absolute', left: 0, bottom: '-10px', width: '100%'}} />
                            </span></h2>
                        </div>
                    </div>
                </div>
                {/* Chairperson - centered */}
                <div className="row justify-content-center mb-4">
                    {Teams.slice(0, 1).map((team, titem) => (
                        <div className="col-lg-3 col-md-6 col-12" key={titem}>
                            <div className="vol-card">
                                <div className="image">
                                    <img src={team.timg} alt="" />
                                    <span className="hover-icon"><i className="flaticon-share"></i></span>
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-camera"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-facebook-app-symbol"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-linkedin"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-twitter"></i></Link></li>
                                    </ul>
                                </div>
                                <div className="text">
                                    <h3><Link onClick={ClickHandler} to={`/volunteer-single/${team.slug}`}>{team.title}</Link></h3>
                                    <span>{team.subtitle}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {/* Directors - 4 cards */}
                <div className="row">
                    {Teams.slice(1, 5).map((team, titem) => (
                        <div className="col-lg-3 col-md-6 col-12" key={titem}>
                            <div className="vol-card">
                                <div className="image">
                                    <img src={team.timg} alt="" />
                                    <span className="hover-icon"><i className="flaticon-share"></i></span>
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-camera"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-facebook-app-symbol"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-linkedin"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-twitter"></i></Link></li>
                                    </ul>
                                </div>
                                <div className="text">
                                    <h3><Link onClick={ClickHandler} to={`/volunteer-single/${team.slug}`}>{team.title}</Link></h3>
                                    <span>{team.subtitle}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="all-btn">
                    <Link onClick={ClickHandler} to="/people" className="theme-btn">View All Members</Link>
                </div>
            </div>
        </section>
    )
}
export default TeamSection;
